import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { IFundSchedulesService } from "services/FundSchedulesService";
import { RootState } from "setup";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

const initialState = {
  FundScheduleSelectModels: new Array<IntSelectModel>(),
  ServiceChargeOnlyModels: new Array<IntSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
  ServiceChargeLastUpdatedTme: new Date(),
};

export const fundScheduleSelectSlice = createSlice({
  name: "fundScheduleSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFundScheduleSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getFundScheduleSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getFundScheduleSelectModels.fulfilled, (state, action) => {
        if (action.meta.arg?.isServiceChargeOnly === true) {
          state.ServiceChargeOnlyModels = action.payload;
          state.ServiceChargeLastUpdatedTme = new Date();
        } else {
          state.FundScheduleSelectModels = action.payload;
          state.LastUpdateTime = new Date();
        }
        state.Loading = false;
      });
  },
});

export const getFundScheduleSelectModels = createAsyncThunk(
  "FundSchedule/GetSelectModels",
  async (params?: { isServiceChargeOnly?: boolean; developmentIDs?: string[] }) => {
    const fundSchedulesService = container.get<IFundSchedulesService>(SERVICE_TYPES.FundSchedulesService);
    return await fundSchedulesService.getSelectModels(params?.isServiceChargeOnly, params?.developmentIDs);
  }
);

export const selectFundScheduleSelectModels = (state: RootState) => {
  return state.fundScheduleSelect.FundScheduleSelectModels;
};

export const selectServiceChargeOnlyModels = (state: RootState) => {
  return state.fundScheduleSelect.ServiceChargeOnlyModels;
};

export const selectLoading = (state: RootState) => {
  return state.fundScheduleSelect.Loading;
};

export const selectLastUpdateTime = (state: RootState) => {
  return state.fundScheduleSelect.LastUpdateTime;
};
export const selectServiceChargeLastUpdatedTime = (state: RootState) => {
  return state.fundScheduleSelect.ServiceChargeLastUpdatedTme;
};

export default fundScheduleSelectSlice.reducer;
